import { ISlice } from './constants'

export const sliceArraysEqual = (a: ISlice[], b: ISlice[]): boolean => {
  if (a.length !== b.length) {
    return false
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false
    }
  }
  return true
}

export const isKeyEvent = (
  event: React.KeyboardEvent,
  code: string,
  keyCode: number,
  withMeta = true,
) => {
  const isMeta = !withMeta || event.ctrlKey === true || event.metaKey === true
  return isMeta && (event.nativeEvent.code === code || event.keyCode === keyCode)
}

export const isBoldToggleEvent = (
  event: React.KeyboardEvent<HTMLDivElement | HTMLTextAreaElement>,
) => {
  return isKeyEvent(event, 'KeyB', 66)
}

export const isItalicToggleEvent = (
  event: React.KeyboardEvent<HTMLDivElement | HTMLTextAreaElement>,
) => {
  return isKeyEvent(event, 'KeyI', 73)
}

export const isUnderlineToggleEvent = (
  event: React.KeyboardEvent<HTMLDivElement | HTMLTextAreaElement>,
) => {
  return isKeyEvent(event, 'KeyU', 85)
}
